<template>
	<button
		:id="context.id"
		ref="button"
		type="button"
		:class="props.context.classes.input"
		:disabled="context.disabled"
		@click="handleClick"
	>
		<span :class="[context.classes.inputLabel, {'text-body-tertiary': !props.context.attrs['input-value']}]">
			{{ props.context.attrs['input-value'] || props.context.attrs.placeholder }}
		</span>
		<component
			:is="context.slots.icon"
			v-if="context.slots.icon"
		/>
	</button>
</template>

<script setup lang="ts">
	import type {FormkitPickupButton} from '~/types/formkitPickupButton';

	interface Props {
		context: FormkitPickupButton
	}

	const props = defineProps<Props>();

	function handleClick() {
		props.context.node.emit('onClick');
	}
</script>
